var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app_wrap"},[_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.showFloat)?_c('div',{class:['float_box', _vm.sliding ? 'slidein' : 'slideout'],on:{"click":_vm.gotoApp}},[_vm._v("\n      APP打开\n    ")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10d0c437","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toApp.vue
// module id = null
// module chunks = 